<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.employeeOperations')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-cutlery"></i>
          <span>{{$ml.get('shared.diningHall')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.employeeOperations')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-3">
          <div class="input-group" style="margin-bottom:7px;">
            <input
              type="text"
              :placeholder="$ml.get('foodGroupOperations.searchEmployeeInList')"
              v-model="searchText"
              class="form-control"
            />
            <span class="input-group-btn">
              <button type="button" class="btn btn-primary">
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
          <div class="box box-primary">
            <div class="box-header with-border">
              <i class="fa fa-user"></i>
              <h3 class="box-title">
                <span>{{$ml.get('foodGroupOperations.employeeList')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  data-toggle="modal"
                  data-target="#modal-filtre"
                >
                  <i class="fa fa-filter"></i>
                </button>
              </div>
            </div>
            <div class="box-body">
              <div
                v-show="employeeList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th @click="setOrderEmp(1)" style="cursor:pointer;min-width:75px;">
                        <strong>
                          {{$ml.get('employees.registrationNumberInfo')}}
                          <i
                            v-show="orderEmpList == 1"
                            class="fa fa-sort-numeric-asc"
                          ></i>
                          <i v-show="orderEmpList == 2" class="fa fa-sort-numeric-desc"></i>
                        </strong>
                      </th>
                      <th @click="setOrderEmp(2)" style="cursor:pointer;">
                        <strong>
                          {{$ml.get('employees.nameSurname')}}
                          <i
                            v-show="orderEmpList == 3"
                            class="fa fa-sort-alpha-asc"
                          ></i>
                          <i v-show="orderEmpList == 4" class="fa fa-sort-alpha-desc"></i>
                        </strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="employee.id == employee1.id ? 'bg-primary': ''"
                      style="cursor:pointer;"
                      @click="getEmployee(employee1.id)"
                      v-for="employee1 in filtered"
                      :key="employee1.id"
                    >
                      <td>{{employee1.sicilNo}}</td>
                      <td>
                        {{employee1.name}}
                        <span v-show="employee1.title">({{employee1.title}})</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="employeeList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{$ml.get('foodGroupOperations.employeeSearchNotFound')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingEmployee">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('foodGroupOperations.employeeInfo')}}</span>
              </h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-3">
                  <div class="box box-primary">
                    <div class="box-body box-profile">
                      <img
                        class="profile-user-img img-responsive img-circle"
                        :src="(this.employee.image == null && this.tempUrl == null) || (this.employee.image == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.employee.image || this.tempUrl"
                        style="height:150px;width:150px;"
                      />
                      <hr />
                      <h3 class="profile-username text-center">
                        <span v-show="employee.name != ''">{{employee.name}}</span>
                        <span
                          v-show="this.employee.isActive == false"
                          class="badge label-danger"
                        >{{$ml.get('foodGroupOperations.deletedRecord')}}</span>
                      </h3>
                      <p class="text-muted text-center">
                        <span v-show="employee.title != ''">{{employee.title}}</span>
                      </p>
                      <p class="text-muted text-center">
                        <span
                          v-show="employee.departmentId != null"
                        >{{getDepartmentFromId(employee.departmentId)}}</span>
                      </p>
                      <ul class="list-group list-group-unbordered">
                        <li class="list-group-item">
                          <b>
                            <span>{{$ml.get('foodGroupOperations.registrationNumber')}}</span> :
                          </b>
                          <a class="pull-right">
                            <span v-show="employee.sicilNo == ''">-</span>
                            <span v-show="employee.sicilNo != ''">{{employee.sicilNo}}</span>
                          </a>
                        </li>
                        <li class="list-group-item">
                          <b>
                            <span>Güncel Bakiye</span> :
                          </b>
                          <a class="pull-right">
                            <span
                              class="label label-primary"
                              style="font-size:small;"
                            >{{employee.remainder}}</span>
                          </a>
                        </li>
                        <li v-show="selectedFoodGroupType == 2" class="list-group-item">
                          <b>
                            <span>Güncel Kredi</span> :
                          </b>
                          <a class="pull-right">
                            <span
                              class="label label-primary"
                              style="font-size:small;"
                            >{{employee.credit}}</span>
                          </a>
                        </li>
                        <li class="list-group-item">
                          <b>
                            <span>{{$ml.get('foodGroupOperations.dateOfStartWork')}}</span> :
                          </b>
                          <a class="pull-right">
                            <span v-show="employee.startDate == null">-</span>
                            <span
                              v-show="employee.startDate != ''"
                            >{{employee.startDate | toDateFormatGet("gg.aa.yyyy")}}</span>
                          </a>
                        </li>
                        <li class="list-group-item">
                          <b>
                            <span>{{$ml.get('foodGroupOperations.dateOfEndWork')}}</span> :
                          </b>
                          <a class="pull-right">
                            <span v-show="employee.endDate == null">-</span>
                            <span
                              v-show="employee.endDate != ''"
                            >{{employee.endDate | toDateFormatGet("gg.aa.yyyy")}}</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li class="active">
                        <a
                          href="#yemek-grubu"
                          data-toggle="tab"
                          aria-expanded="true"
                        >{{$ml.get('foodGroupOperations.foodGroup')}}</a>
                      </li>
                      <li>
                        <a
                          href="#hareketler"
                          data-toggle="tab"
                          aria-expanded="true"
                        >{{$ml.get('foodGroupOperations.movements')}}</a>
                      </li>
                      <li>
                        <a
                          href="#retail-sale-logs"
                          data-toggle="tab"
                          aria-expanded="true"
                        >{{$ml.get('foodGroupOperations.retailSaleLogs')}}</a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane active" id="yemek-grubu">
                        <div class="row" style="margin-bottom:10px;">
                          <div class="col-sm-9">
                            <select @change="changeFoodGroup($event)" class="form-control">
                              <option
                                :selected="employee.foodGroupId == 0"
                                :value="0"
                              >{{$ml.get('general.notSelected')}}</option>
                              <option
                                v-for="foodGroup in foodGroupList"
                                :key="foodGroup.id"
                                :selected="employee.foodGroupId == foodGroup.id"
                                :value="foodGroup.id"
                              >{{foodGroup.name}}</option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <button
                              :disabled="isNewEmployee && authControl == 0"
                              type="button"
                              class="btn btn-success"
                              style="width:100%;"
                              data-toggle="modal"
                              data-target="#modal-guncelle"
                            >{{$ml.get('general.update')}}</button>
                          </div>
                        </div>
                        <div class="row">
                          <div
                            class="col-sm-6"
                            v-show="selectedFoodGroupType == 3 || modules.dormitory"
                          >
                            <div class="form-group">
                              <label>{{$ml.get('foodGroupOperations.availableBalance')}}</label>
                              <div class="input-group">
                                <label v-text="employee.remainder" class="form-control"></label>
                                <span class="input-group-btn">
                                  <button
                                    @click="selectFoodType(2, employee.remainder)"
                                    data-toggle="modal"
                                    data-target="#modal-yemek"
                                    class="btn btn-primary"
                                  >
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6" v-show="selectedFoodGroupType == 2">
                            <div class="form-group">
                              <label>{{$ml.get('foodGroupOperations.remainingCredits')}}</label>
                              <div class="input-group">
                                <label v-text="employee.credit" class="form-control"></label>
                                <span class="input-group-btn">
                                  <button
                                    @click="selectFoodType(1, employee.credit)"
                                    data-toggle="modal"
                                    data-target="#modal-yemek"
                                    class="btn btn-primary"
                                  >
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3
                                  class="box-title"
                                >{{$ml.get('foodGroupOperations.foodBalanceLogs')}}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button
                                      v-show="foodBalanceLogList.length > 0 && authControl == 0"
                                      @click="exportToPDFBakiyeHareketleri()"
                                      type="button"
                                      class="btn btn-danger btn-sm"
                                    >
                                      <i class="fa fa-share"></i>
                                      {{$ml.get('general.exportToPdfOrPrint')}}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div
                                  id="printBakiyeLoglari"
                                  v-show="foodBalanceLogList.length > 0"
                                  class="table-responsive no-padding"
                                  style="max-height:350px;owerflow:auto;"
                                >
                                  <div align="center">
                                    <span
                                      v-show="foodBalanceLogList.length > 0"
                                    >{{employee.sicilNo}} - {{employee.name}} ({{new Date() | toDateFormatGet("gg.aa.yyyy ss:dd")}})</span>
                                  </div>
                                  <table class="table table-hover">
                                    <tbody>
                                      <tr>
                                        <th
                                          class="text-center"
                                          style="width:130px"
                                        >{{$ml.get('foodGroupOperations.time')}}</th>
                                        <th
                                          class="text-center"
                                        >{{$ml.get('foodGroupOperations.amount')}}</th>
                                        <th
                                          class="text-center"
                                        >{{$ml.get('foodGroupOperations.type')}}</th>
                                        <th
                                          class="text-center"
                                        >{{$ml.get('foodGroupOperations.status')}}</th>
                                      </tr>
                                      <tr
                                        v-for="foodBalance in foodBalanceLogList"
                                        :key="foodBalance.id"
                                      >
                                        <td
                                          class="text-center"
                                        >{{foodBalance.date | toDateFormatGet("gg.aa.yyyy ss:dd")}}</td>
                                        <td class="text-center text-bold">{{foodBalance.amount}}</td>
                                        <td class="text-center">
                                          <span
                                            class="badge label-primary"
                                            v-text="foodBalance.type == 1 ? $ml.get('general.credit') : $ml.get('general.balance')"
                                          ></span>
                                        </td>
                                        <td class="text-center">
                                          <span
                                            v-show="foodBalance.isAdded"
                                            class="badge label-success"
                                          >{{$ml.get('general.added')}}</span>
                                          <span
                                            v-show="!foodBalance.isAdded"
                                            class="badge label-danger"
                                          >{{$ml.get('general.removed')}}</span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div
                                  v-show="foodBalanceLogList.length == 0"
                                  class="callout callout-info"
                                >
                                  <i class="fa fa-info-circle"></i>
                                  {{$ml.get('foodGroupOperations.foodBalanceLogNotRecord')}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--YEMEK GRUBU SONU-->
                      <div class="tab-pane" id="hareketler">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{$ml.get('foodGroupOperations.movements')}}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button
                                      v-show="inOutList.length > 0 && authControl == 0"
                                      @click="exportToPDFHareketler()"
                                      type="button"
                                      class="btn btn-danger btn-sm"
                                    >
                                      <i class="fa fa-share"></i>
                                      {{$ml.get('general.exportToPdfOrPrint')}}
                                    </button>
                                    <button
                                      :disabled="isNewEmployee || authControl == 1"
                                      v-show="employee.isActive != false"
                                      type="button"
                                      data-toggle="modal"
                                      data-target="#modal-hareket-ekle"
                                      @click="newInOut()"
                                      class="btn btn-warning btn-sm"
                                    >
                                      <i class="fa fa-plus"></i>
                                      {{$ml.get('foodGroupOperations.newMovement')}}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row" style="margin-top:5px">
                                  <div
                                    class="col-md-12 col-lg-6 col-sm-12"
                                    style="margin-bottom:10px"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{$ml.get('foodGroupOperations.startDateMovements')}}</span> :
                                        </button>
                                      </div>
                                      <input
                                        v-model="inOut.inOutStartDate"
                                        type="datetime-local"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    class="col-md-12 col-lg-6 col-sm-12"
                                    style="margin-bottom:5px;"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{$ml.get('foodGroupOperations.endDateMovements')}}</span> :
                                        </button>
                                      </div>
                                      <input
                                        v-model="inOut.inOutEndDate"
                                        type="datetime-local"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div
                                    class="col-sm-12"
                                    style="margin-bottom:10px; text-align:center"
                                  >
                                    <button
                                      :disabled="isLoadingInOuts"
                                      @click="getInOuts()"
                                      type="button"
                                      class="btn btn-primary btn-sm"
                                      style="width:90%"
                                    >
                                      <i class="fa fa-search"></i>
                                      {{$ml.get('foodGroupOperations.searchMovements')}}
                                    </button>
                                  </div>
                                </div>
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div
                                    id="printHareketler"
                                    v-show="inOutList.length > 0"
                                    class="table-responsive no-padding"
                                    style="max-height:350px;owerflow:auto;"
                                  >
                                    <div align="center">
                                      <span
                                        v-show="inOutList.length > 0"
                                      >{{employee.sicilNo}} - {{employee.name}} ({{this.inOut.inOutStartDate | toDateFormatGet("gg.aa.yyyy ss:dd")}} - {{this.inOut.inOutEndDate | toDateFormatGet("gg.aa.yyyy ss:dd")}})</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th
                                            style="width:130px"
                                          >{{$ml.get('foodGroupOperations.timeMovement')}}</th>
                                          <th>{{$ml.get('foodGroupOperations.deviceMovement')}}</th>
                                          <th>{{$ml.get('foodGroupOperations.statusMovement')}}</th>
                                          <th>{{$ml.get('foodGroupOperations.price')}}</th>
                                          <th style="width:30px"></th>
                                          <th style="width:100px"></th>
                                        </tr>
                                        <tr v-for="inOut2 in inOutFiltered" :key="inOut2.id">
                                          <td>{{inOut2.date | toDateFormatGet("gg.aa.yyyy ss:dd")}}</td>
                                          <td>
                                            <span
                                              v-show="inOut2.readerId != 0"
                                            >{{inOut2.readerName}}</span>
                                            <span
                                              v-show="inOut2.readerId == 0"
                                            >{{$ml.get('foodGroupOperations.manuelMovement')}}</span>
                                          </td>
                                          <td>
                                            <span
                                              v-show="inOut2.inOrOut != 2"
                                              class="label btn-success"
                                            >{{$ml.get('foodGroupOperations.entryMovement')}}</span>
                                            <span
                                              v-show="inOut2.inOrOut == 2"
                                              class="label btn-danger"
                                            >{{$ml.get('foodGroupOperations.exitMovement')}}</span>
                                          </td>
                                          <td>
                                            {{inOut2.price}}
                                            <span v-show="inOut2.price"></span>
                                          </td>
                                          <td>
                                            <span
                                              v-show="!inOut2.isActive"
                                              class="badge"
                                            >{{$ml.get('employees.passive')}}</span>
                                          </td>
                                          <td>
                                            <button
                                              v-show="employee.isActive != false && authControl == 0"
                                              type="button"
                                              class="btn btn-xs btn-danger"
                                              @click="deleteInOut(inOut2.id)"
                                            >
                                              <i class="fa fa-close"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div v-show="inOutList.length == 0" class="callout callout-info">
                                    <i class="fa fa-info-circle"></i>
                                    {{$ml.get('foodGroupOperations.movementNotRecord')}}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingInOuts">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--HAREKETLER SONU-->
                      <div class="tab-pane" id="retail-sale-logs">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="box box-primary">
                              <div class="box-header">
                                <h3 class="box-title">{{$ml.get('foodGroupOperations.retailSaleLogs')}}</h3>
                                <div class="box-tools">
                                  <div class="pull-right">
                                    <button
                                      v-show="retailSaleLogList.length > 0 && authControl == 0"
                                      @click="exportToPDFSaleLogs()"
                                      type="button"
                                      class="btn btn-danger btn-sm"
                                    >
                                      <i class="fa fa-share"></i>
                                      {{$ml.get('general.exportToPdfOrPrint')}}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body">
                                <div class="row" style="margin-top:5px">
                                  <div
                                    class="col-md-12 col-lg-6 col-sm-12"
                                    style="margin-bottom:10px"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{$ml.get('foodGroupOperations.startDateMovements')}}</span> :
                                        </button>
                                      </div>
                                      <input
                                        v-model="retailSaleLogs.startDate"
                                        type="datetime-local"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    class="col-md-12 col-lg-6 col-sm-12"
                                    style="margin-bottom:5px;"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-btn">
                                        <button class="btn" style="max-width:120px;">
                                          <span>{{$ml.get('foodGroupOperations.endDateMovements')}}</span> :
                                        </button>
                                      </div>
                                      <input
                                        v-model="retailSaleLogs.endDate"
                                        type="datetime-local"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div
                                    class="col-sm-12"
                                    style="margin-bottom:10px; text-align:center"
                                  >
                                    <button
                                      :disabled="isLoadingRetailSale"
                                      @click="getRetailSaleLogs()"
                                      type="button"
                                      class="btn btn-primary btn-sm"
                                      style="width:90%"
                                    >
                                      <i class="fa fa-search"></i>
                                      {{$ml.get('foodGroupOperations.searchMovements')}}
                                    </button>
                                  </div>
                                </div>
                                <div class="row col-sm-12" style="margin: 0px 5px 10px 0px;">
                                  <div
                                    id="printSatisHareketleri"
                                    v-show="retailSaleLogList.length > 0"
                                    class="table-responsive no-padding"
                                    style="max-height:350px;owerflow:auto;"
                                  >
                                    <div align="center">
                                      <span
                                        v-show="retailSaleLogList.length > 0"
                                      >{{employee.sicilNo}} - {{employee.name}} ({{this.retailSaleLogs.startDate | toDateFormatGet("gg.aa.yyyy ss:dd")}} - {{this.retailSaleLogs.endDate | toDateFormatGet("gg.aa.yyyy ss:dd")}})</span>
                                    </div>
                                    <table class="table table-hover">
                                      <tbody>
                                        <tr>
                                          <th class="text-left" style="width:130px">Tarih</th>
                                          <th class="text-left">Durum</th>
                                          <th class="text-left">İşletme</th>
                                          <th class="text-left">Tutar</th>
                                        </tr>
                                        <tr v-for="saleLog in retailSaleLogList" :key="saleLog.id">
                                          <td>{{saleLog.date}}</td>
                                          <td>
                                            <span v-show="saleLog.isRefund">
                                              <i class="fa fa-times-circle text-danger"></i> İade Edildi
                                            </span>
                                          </td>
                                          <td>{{saleLog.user}}</td>
                                          <td>{{saleLog.price}}</td>
                                        </tr>
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td style="text-align:right;font-weight:bold;">Toplam : </td>
                                          <td style="font-weight:bold;">{{retailSaleLogTotalPrice}}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div
                                    v-show="retailSaleLogList.length == 0"
                                    class="callout callout-info"
                                  >
                                    <i class="fa fa-info-circle"></i>
                                    {{$ml.get('foodGroupOperations.movementNotRecord')}}
                                  </div>
                                </div>
                              </div>
                              <!-- /.box-body -->
                              <div class="overlay" id="load" :hidden="!isLoadingRetailSale">
                                <i class="fa fa-refresh fa-spin"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--SATIŞ HAREKETLERİ SONU-->
                    </div>
                  </div>
                  <!-- NAV TABS END -->
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.update')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.employee.name}}</span>
                <span v-show="this.employee.title != ''">- {{this.employee.title}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('foodGroupOperations.isContinueUpdateEmployeeFoodGroup')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveEmployee()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-primary fade" id="modal-filtre">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('filters.filterEmployees')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <span>{{$ml.get('filters.filterNameSurnameOrCardNo')}}</span>
                    <input
                      v-model="filters.nameOrCardNumber"
                      type="text"
                      class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterNameSurnameOrCardNo')"
                      style="margin-bottom:5px;"
                    />
                  </div>
                  <div class="form-group">
                    <span>{{$ml.get('filters.filterCitizenshipNumber')}}</span>
                    <input
                      v-model="filters.identityNo"
                      type="text"
                      class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterCitizenshipNumber')"
                      style="margin-bottom:5px;"
                    />
                  </div>
                  <div class="form-group">
                    <span>{{$ml.get('filters.filterRegistrationOrDeviceNo')}}</span>
                    <input
                      v-model="filters.sicilOrTerminalNo"
                      type="text"
                      class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterRegistrationOrDeviceNo')"
                      style="margin-bottom:5px;"
                    />
                  </div>
                  <div class="form-group">
                    <span>{{$ml.get('filters.filterTitle')}}</span>
                    <select
                      @change="changeFilterTitles($event)"
                      class="form-control input-sm"
                      style="margin-bottom:5px;"
                    >
                      <option :selected="filters.title == ''" value>{{$ml.get('general.select')}}</option>
                      <option
                        v-for="title in titleList"
                        :key="title.name"
                        :value="title.name"
                        :selected="title.name == filters.title"
                      >{{title.name}}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{$ml.get('filters.filterStatus')}}</label>
                    <div class="input-group">
                      <label
                        v-show="checkedStatusList != ''"
                        class="form-control tdb-box"
                      >{{checkedStatusList}}</label>
                      <label
                        v-show="checkedStatusList == ''"
                        class="form-control"
                      >{{$ml.get('general.notSelected')}}</label>
                      <div class="input-group-btn">
                        <button
                          class="btn btn-default"
                          data-toggle="modal"
                          data-target="#modal-select-status"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          v-show="checkedStatusList != ''"
                          class="btn btn-danger"
                          @click="clearFilterStatus()"
                        >
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <span>{{$ml.get('filters.filterDocumentNoOrEmail')}}</span>
                    <input
                      v-model="filters.documentNoOrMail"
                      type="text"
                      class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterDocumentNoOrEmail')"
                      style="margin-bottom:5px;"
                    />
                  </div>
                  <div class="form-group" v-show="modules.licencePlateRecognition">
                    <span>{{$ml.get('filters.filterPlateNo')}}</span>
                    <input
                      v-model="filters.plateNo"
                      type="text"
                      class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterPlateNo')"
                      style="margin-bottom:5px;"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>{{$ml.get('filters.filterDepartments')}}</label>
                    <div class="input-group">
                      <label
                        v-show="checkedDepartmentList != ''"
                        class="form-control tdb-box"
                      >{{checkedDepartmentList}}</label>
                      <label
                        v-show="checkedDepartmentList == ''"
                        class="form-control"
                      >{{$ml.get('general.notSelected')}}</label>
                      <div class="input-group-btn">
                        <button
                          class="btn btn-default"
                          data-toggle="modal"
                          data-target="#modal-select-department"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          v-show="checkedDepartmentList != ''"
                          class="btn btn-danger"
                          @click="clearFilterDepartments()"
                        >
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{$ml.get('filters.filterAccessGroup')}}</label>
                    <div class="input-group">
                      <label
                        v-show="checkedAccessGroupList != ''"
                        class="form-control tdb-box"
                      >{{checkedAccessGroupList}}</label>
                      <label
                        v-show="checkedAccessGroupList == ''"
                        class="form-control"
                      >{{$ml.get('general.notSelected')}}</label>
                      <div class="input-group-btn">
                        <button
                          class="btn btn-default"
                          data-toggle="modal"
                          data-target="#modal-select-access"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          v-show="checkedAccessGroupList != ''"
                          class="btn btn-danger"
                          @click="clearFilterAccessGroup()"
                        >
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{$ml.get('filters.filterWorkPlan')}}</label>
                    <div class="input-group">
                      <label
                        v-show="checkedWorkGroupList != ''"
                        class="form-control tdb-box"
                      >{{checkedWorkGroupList}}</label>
                      <label
                        v-show="checkedWorkGroupList == ''"
                        class="form-control"
                      >{{$ml.get('general.notSelected')}}</label>
                      <div class="input-group-btn">
                        <button
                          class="btn btn-default"
                          data-toggle="modal"
                          data-target="#modal-select-workplan"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          v-show="checkedWorkGroupList != ''"
                          class="btn btn-danger"
                          @click="clearFilterWorkPlans()"
                        >
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-show="modules.diningHall">
                    <label>{{$ml.get('filters.filterFoodGroup')}}</label>
                    <div class="input-group">
                      <label
                        v-show="checkedFoodGroupList != ''"
                        class="form-control tdb-box"
                      >{{checkedFoodGroupList}}</label>
                      <label
                        v-show="checkedFoodGroupList == ''"
                        class="form-control"
                      >{{$ml.get('general.notSelected')}}</label>
                      <div class="input-group-btn">
                        <button
                          class="btn btn-default"
                          data-toggle="modal"
                          data-target="#modal-select-diningHall"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          v-show="checkedFoodGroupList != ''"
                          class="btn btn-danger"
                          @click="clearFilterFoodGroups()"
                        >
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{$ml.get('filters.filterState')}}</label>
                    <div class="input-group">
                      <label
                        v-show="checkedStateList != ''"
                        class="form-control tdb-box"
                      >{{checkedStateList}}</label>
                      <label
                        v-show="checkedStateList == ''"
                        class="form-control"
                      >{{$ml.get('general.notSelected')}}</label>
                      <div class="input-group-btn">
                        <button
                          class="btn btn-default"
                          data-toggle="modal"
                          data-target="#modal-select-state"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          v-show="checkedStateList != ''"
                          class="btn btn-danger"
                          @click="clearFilterStates()"
                        >
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-sm-6">
                      <span>{{$ml.get('filters.filterDeleted')}}</span>
                      <span class="form-control checkbox">
                        <label style="margin-left:20px;">
                          <input
                            :checked="filters.isActive"
                            @change="filters.isActive==true ? filters.isActive=false : filters.isActive=true"
                            type="checkbox"
                          />
                          {{$ml.get('filters.filterNotShow')}}
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="callout callout-info" style="margin-top:10px;">
                <div class="row">
                  <div class="col-md-3 col-xs-6">
                    <select
                      @change="changeFilterExtraField1($event)"
                      class="form-control input-sm"
                      style="margin-bottom:5px;"
                    >
                      <option
                        :selected="filters.extraField1key == 0"
                        value
                      >{{$ml.get('filters.filterSelectExtraFields')}}</option>
                      <option
                        v-for="extraField in extraFieldList"
                        :key="extraField.id"
                        :value="extraField.id"
                        :selected="extraField.id == filters.extraField1key"
                      >{{extraField.name}}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input
                      v-model="filters.extraField1value"
                      type="text"
                      class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')"
                      style="margin-bottom:5px;"
                    />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select
                      @change="changeFilterExtraField2($event)"
                      class="form-control input-sm"
                      style="margin-bottom:5px;"
                    >
                      <option
                        :selected="filters.extraField2key == 0"
                        value
                      >{{$ml.get('filters.filterSelectExtraFields')}}</option>
                      <option
                        v-for="extraField in extraFieldList"
                        :key="extraField.id"
                        :value="extraField.id"
                        :selected="extraField.id == filters.extraField2key"
                      >{{extraField.name}}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input
                      v-model="filters.extraField2value"
                      type="text"
                      class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')"
                      style="margin-bottom:5px;"
                    />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select
                      @change="changeFilterExtraField3($event)"
                      class="form-control input-sm"
                      style="margin-bottom:5px;"
                    >
                      <option
                        :selected="filters.extraField3key == 0"
                        value
                      >{{$ml.get('filters.filterSelectExtraFields')}}</option>
                      <option
                        v-for="extraField in extraFieldList"
                        :key="extraField.id"
                        :value="extraField.id"
                        :selected="extraField.id == filters.extraField3key"
                      >{{extraField.name}}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input
                      v-model="filters.extraField3value"
                      type="text"
                      class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')"
                      style="margin-bottom:5px;"
                    />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select
                      @change="changeFilterExtraField4($event)"
                      class="form-control input-sm"
                      style="margin-bottom:5px;"
                    >
                      <option
                        :selected="filters.extraField4key == 0"
                        value
                      >{{$ml.get('filters.filterSelectExtraFields')}}</option>
                      <option
                        v-for="extraField in extraFieldList"
                        :key="extraField.id"
                        :value="extraField.id"
                        :selected="extraField.id == filters.extraField4key"
                      >{{extraField.name}}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input
                      v-model="filters.extraField4value"
                      type="text"
                      class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')"
                      style="margin-bottom:5px;"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              <i class="fa fa-remove"></i>
              <span>{{$ml.get('filters.filterCancel')}}</span>
            </button>
            <button @click="filtersClear()" class="btn btn-warning">
              <i class="fa fa-trash-o"></i>
              <span>{{$ml.get('filters.filterClear')}}</span>
            </button>
            <button @click="getEmployees()" class="btn btn-success" data-dismiss="modal">
              <i class="fa fa-search"></i>
              <span>{{$ml.get('filters.filterApply')}}</span>
            </button>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!--HAREKET EKLE MODAL -->
      <div class="modal modal-primary fade" id="modal-hareket-ekle" style="display: none;">
        <div class="modal-dialog modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('foodGroupOperations.newMovement')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="callout callout-warning">
                    <i class="fa fa-info-circle"></i>
                    {{$ml.get('foodGroupOperations.newMovementWarningInfo')}}
                  </div>
                </div>
                <div class="form-group col-sm-12">
                  <label>{{$ml.get('foodGroupOperations.dateMovement')}}</label>
                  <input
                    @change="getMeals(employee.foodGroupId, inOut.inOutAdd)"
                    v-model="inOut.inOutAdd"
                    type="date"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-sm-12">
                  <label>{{$ml.get('foodGroupOperations.meal')}}</label>
                  <select @change="changeMeal($event)" class="form-control">
                    <option
                      value="0"
                      :selected="selectedMealTime == ''"
                    >{{$ml.get('general.notSelected')}}</option>
                    <option
                      v-for="(meal,index) in mealList"
                      :key="index"
                      :value="meal.start"
                      :selected="selectedMealTime == meal.start"
                    >{{meal.name}} ({{meal.start}} - {{meal.end}})</option>
                  </select>
                </div>
                <div class="form-group col-sm-12">
                  <label>{{$ml.get('foodGroupOperations.readerMovement')}}</label>
                  <select @change="changeInOutDoor($event)" class="form-control">
                    <option
                      value="0"
                      :selected="inOut.readerId == 0"
                    >{{$ml.get('general.notSelected')}}</option>
                    <option
                      v-for="door in activeReaderList"
                      :key="door.readerId"
                      :value="door.readerId"
                      :selected="door.readerId == inOut.readerId"
                    >{{door.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline pull-left"
                data-dismiss="modal"
              >{{$ml.get('general.cancel')}}</button>
              <button
                v-show="isNewInOut"
                type="button"
                @click="addInOut()"
                class="btn btn-outline"
                data-dismiss="modal"
              >{{$ml.get('general.save')}}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--HAREKET EKLE MODAL END -->
      <!--YEMEK MODAL -->
      <div class="modal modal-primary fade" id="modal-yemek" style="display: none;">
        <div class="modal-dialog modal-dialog-centered modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span v-show="selectedFoodType == 1">{{$ml.get('foodGroupOperations.addCredit')}}</span>
                <span v-show="selectedFoodType == 2">{{$ml.get('foodGroupOperations.addBalance')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div v-show="selectedFoodType == 1">
                <p>{{$ml.get('foodGroupOperations.amountOfCredit')}}</p>
                <div class="input-group">
                  <div class="input-group-btn">
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="selectedFoodCount > 0 ? selectedFoodCount -= 1 : selectedFoodCount"
                    >
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                  <input
                    v-model="selectedFoodCount"
                    type="number"
                    min="0"
                    value="0"
                    class="form-control"
                  />
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-success" @click="selectedFoodCount += 1">
                      <i class="fa fa-plus"></i>
                    </button>
                  </span>
                </div>
              </div>
              <div v-show="selectedFoodType == 2" class="input-group">
                <p>{{$ml.get('foodGroupOperations.amountOfBalance')}}</p>
                <input v-model="selectedFoodCount" type="text" class="form-control" />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline pull-left"
                data-dismiss="modal"
              >{{$ml.get('general.cancel')}}</button>
              <button
                type="button"
                @click="updateFoodCredit()"
                class="btn btn-outline btn-success"
                data-dismiss="modal"
              >
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK MODAL END -->
      <!--DEPARTMAN SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('filters.filterDepartments')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <a
                @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)"
              >
                <span
                  v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"
                ></span>
              </a>
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span
                  class="form-control checkbox"
                  v-for="dep in sortableDepartmentList"
                  :key="dep.id"
                >
                  <label style="margin-left:20px;">
                    <input
                      :checked="dep.check"
                      @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                      type="checkbox"
                    />
                    {{dep.name}}
                  </label>
                </span>
                <div
                  class="callout callout-warning"
                  v-show="sortableDepartmentList.length == 0"
                >{{$ml.get('employees.departmentNotRecord')}}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" M data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{$ml.get('general.done')}}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN SEÇ MODAL END -->
      <!--DURUM SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('filters.filterState')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="state in stateList" :key="state.id">
                  <label style="margin-left:20px;">
                    <input
                      :checked="state.isCheck"
                      @change="state.isCheck==true ? state.isCheck=false : state.isCheck=true"
                      type="checkbox"
                    />
                    {{state.name}}
                  </label>
                </span>
                <div
                  class="callout callout-warning"
                  v-show="stateList.length == 0"
                >{{$ml.get('employees.stateNotRecord')}}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{$ml.get('general.done')}}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DURUM SEÇ MODAL END -->
      <!--STATU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('filters.filterStatus')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="status in statuList" :key="status.id">
                  <label style="margin-left:20px;">
                    <input
                      :checked="status.isCheck"
                      @change="status.isCheck==true ? status.isCheck=false : status.isCheck=true"
                      type="checkbox"
                    />
                    {{status.name}}
                  </label>
                </span>
                <div
                  class="callout callout-warning"
                  v-show="statuList.length == 0"
                >{{$ml.get('employees.statusNotRecord')}}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{$ml.get('general.done')}}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU SEÇ MODAL END -->
      <!--GEÇİŞ GRUBU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('filters.filterAccessGroup')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="acc in accessGroupList" :key="acc.id">
                  <label style="margin-left:20px;">
                    <input
                      :checked="acc.isCheck"
                      @change="acc.isCheck==true ? acc.isCheck=false : acc.isCheck=true"
                      type="checkbox"
                    />
                    {{acc.name}}
                  </label>
                </span>
                <div
                  class="callout callout-warning"
                  v-show="accessGroupList.length == 0"
                >{{$ml.get('accessGroups.accessGroupNotRecord')}}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{$ml.get('general.done')}}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GEÇİŞ GRUBU SEÇ MODAL END -->
      <!--ÇALIŞMA PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('filters.filterWorkPlan')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span
                  class="form-control checkbox"
                  v-for="work in periodWorkGroupList"
                  :key="work.id"
                >
                  <label style="margin-left:20px;">
                    <input
                      :checked="work.isCheck"
                      @change="work.isCheck==true ? work.isCheck=false : work.isCheck=true"
                      type="checkbox"
                    />
                    {{work.name}}
                  </label>
                </span>
                <div
                  class="callout callout-warning"
                  v-show="periodWorkGroupList.length == 0"
                >{{$ml.get('workPlans.workPlanNotRecord')}}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{$ml.get('general.done')}}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÇALIŞMA PLANI SEÇ MODAL END -->
      <!--YEMEK PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('filters.filterWorkPlan')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span
                  class="form-control checkbox"
                  v-for="foodGroup in foodGroupList"
                  :key="foodGroup.id"
                >
                  <label style="margin-left:20px;">
                    <input
                      :checked="foodGroup.isCheck"
                      @change="foodGroup.isCheck==true ? foodGroup.isCheck=false : foodGroup.isCheck=true"
                      type="checkbox"
                    />
                    {{foodGroup.name}}
                  </label>
                </span>
                <div
                  class="callout callout-warning"
                  v-show="foodGroupList.length == 0"
                >{{$ml.get('foodGroups.foodGroupNotRecord')}}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{$ml.get('general.done')}}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK PLANI SEÇ MODAL END -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      isLoadingInOuts: false,
      isLoadingEmployee: false,
      windowHeight: window.innerHeight,
      orderEmpList: 1,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      employee: {
        id: null,
        name: "",
        title: "",
        sicilNo: "",
        image: null,
        departmentId: null,
        identityNo: "",
        startDate: null,
        endDate: null,
        workGroupId: null,
        stateId: 1,
        stateNote: "",
        terminalNo: null,
        statuId: null,
        cardNo: "",
        terminalStatu: 0,
        terminalPassword: "",
        accessGroupId: null,
        readers: [],
        overWorkStatus: true,
        salary: null,
        mail: "",
        address: "",
        mobilePhone: "",
        birthDayDate: null,
        internalPhone: "",
        homePhone: "",
        gender: null,
        educationStatus: null,
        militaryStatus: null,
        drivingLicence: "",
        smokeStatus: null,
        maritalStatus: null,
        bloodType: "",
        height: "",
        weight: "",
        disabledPercent: "",
        authorizedPerson1: null,
        authorizedPerson2: null,
        note1: "",
        note2: "",
        foreignLanguage: "",
        foodGroupId: 0,
        credit: 0,
        remainder: "0",
        isVisitor: false,
        visitorCardGroupId: null,
        visitorArea: "",
        isActive: true,
        extrafields: [],
        inOuts: [],
        allowences: [],
        logs: [],
        empPayrolls: [],
        annualPermitId: 0,
        annualPermitSeniority: 0,
        annualPermitTransfer: 0,
        annualPermitClaim: 0,
        annualPermitUsed: 0,
        annualPermitRemain: 0,
        annualPermits: [],
        annualPermitClaimsDates: [],
        salaries: [],
        hasCard: false,
        hasFace: false,
        hasFinger: false,
        hasPassword: false
      },
      inOut: {
        inOutId: null,
        inOutListType: 0,
        inOutListDoorType: 2,
        inOutType: 1,
        inOutAdd: null,
        readerId: "0",
        inOutStartDate: null,
        inOutEndDate: null,
        price: 0
      },
      includePassiveMovements: false,
      doNotDeleteOvertimes: true,
      sortableDepTrees: [],
      selectedFoodType: 1,
      selectedFoodCount: "0",
      foodBalanceLogs: [],
      isNewSalary2: true,
      selectedSalaryId: null,
      selectedSalaryName: "",
      selectedSalaryStatus: 1,
      isNewState: true,
      selectedStateId: null,
      selectedStateName: "",
      selectedStateStatus: false,
      isNewStatu: true,
      selectedStatuId: null,
      selectedStatuName: "",
      searchPayrollStartDate: null,
      searchPayrollEndDate: null,
      selectAP: 1,
      logStartDate: null,
      logEndDate: null,
      allowences: [],
      extrafields: [],
      workGroups: [],
      status: [],
      states: [],
      foodGroups: [],
      titles: [],
      accessGroups: [],
      departments: [],
      employees: [],
      allEmployees: [],
      annualPermits: [],
      visitorCardGroups: [],
      isNewVisitorCardGroup: true,
      selectedVisitorCardGroupId: null,
      selectedVisitorCardGroupName: "",
      selectedVisitorCardGroupDevices: [],
      overtimeDescriptions: [],
      overtimePlaces: [],
      selectedOTDescriptionId: null,
      selectedOTPlaceId: null,
      selectedOverTimeId: null,
      searchText2: "",
      readers: [],
      isCheck: false,
      isCheckDeps: false,
      searchText: "",
      extraFieldKey: "",
      extraFieldValue: "",
      isNewInOut: true,
      isNewEmployee: true,
      isNewSalary: true,
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      selectedFoodGroupType: 0,
      meals: [],
      selectedMealTime: "",
      isLoadingRetailSale: false,
      saleLogs: [],
      retailSaleLogs: {
        empIds: [],
        startDate: null,
        endDate: null
      }
    };
  },
  filters: {
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    retailSaleLogList() {
      return this.saleLogs;
    },
    retailSaleLogTotalPrice() {
      var totalPrice = 0;
      if(this.retailSaleLogList.length > 0){
        this.retailSaleLogList.forEach(item => {
          totalPrice += item.price;
        });
      }
      return totalPrice;
    },
    logList() {
      return this.employee.logs;
    },
    readerList() {
      return this.readers.sort((a, b) => {
        if (a.ipAddress < b.ipAddress) return -1;
        if (a.ipAddress > b.ipAddress) return 0;
      });
    },
    activeReaderList() {
      return this.readerList;
    },
    departmentList() {
      return this.departments;
    },
    sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.sicilNo).localeCompare(
            this.turkishToUpper(b.sicilNo)
          );
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.sicilNo).localeCompare(
            this.turkishToUpper(a.sicilNo)
          );
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.name).localeCompare(
            this.turkishToUpper(b.name)
          );
        });
      } else {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.name).localeCompare(
            this.turkishToUpper(a.name)
          );
        });
      }
    },
    allEmployeeList() {
      return this.allEmployees;
    },
    mealList() {
      return this.meals;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    foodBalanceLogList() {
      return this.foodBalanceLogs;
    },
    titleList() {
      return this.titles;
    },
    stateList() {
      return this.states;
    },
    checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList() {
      return this.status;
    },
    checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList() {
      return this.extrafields;
    },
    employeeExtraFieldList() {
      return this.employee.extrafields;
    },
    workGroupList() {
      return this.workGroups;
    },
    periodWorkGroupList() {
      return this.workGroups.filter(item => {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    EmpPayrollList() {
      return this.employee.empPayrolls;
    },
    inOutList() {
      return this.employee.inOuts;
    },
    allEmployeeFilteredList() {
      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.allEmployeeList.filter(item => {
          return search
            .split(" ")
            .every(
              v =>
                this.turkishToUpper(item.name).includes(v) ||
                this.turkishToUpper(item.sicilNo).includes(v)
            );
        });
      } else {
        return this.allEmployeeList;
      }
    },
    filtered() {
      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeList.filter(item => {
          return search
            .split(" ")
            .every(
              v =>
                this.turkishToUpper(item.name).includes(v) ||
                this.turkishToUpper(item.sicilNo).includes(v)
            );
        });
      } else {
        return this.employeeList;
      }
    },
    inOutFiltered() {
      return this.inOutList.filter(item => {
        return item.doorType == 2;
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 220;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 420;
        return "max-height:" + height + "px;overflow:auto;color:black;";
      } else {
        return "max-height:370px;overflow:auto;color:black;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function(letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    exportToPDFSaleLogs() {
      this.$htmlToPaper("printSatisHareketleri");
    },
    exportToPDFHareketler() {
      this.$htmlToPaper("printHareketler");
    },
    exportToPDFBakiyeHareketleri() {
      this.$htmlToPaper("printBakiyeLoglari");
    },
    setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    getDepartmentFromId(id) {
      let aList = this.departments;
      let dep = aList.filter(function(department) {
        return department.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0].name;
      } else {
        return null;
      }
    },
    getEmpNameFromId(id) {
      let aList = this.allEmployees;
      let emp = aList.filter(function(emp) {
        return emp.id == id;
      });
      if (emp != "" && emp != null) {
        let title = "";
        if (emp[0].title != "") {
          title = " - " + emp[0].title;
        }
        return emp[0].name + title;
      } else {
        return null;
      }
    },
    changeFoodGroup(event) {
      this.employee.foodGroupId = event.target.value;
      this.changeFoodGroupType();
    },
    changeMeal(event) {
      this.selectedMealTime = event.target.value;
    },
    changeInOutDoor(event) {
      this.inOut.readerId = event.target.value;
    },
    changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterAccessGroups(event) {
      this.filters.accessGroup = event.target.value;
    },
    changeFilterFoodGroups(event) {
      this.filters.foodGroup = event.target.value;
    },
    changeFilterStatus(event) {
      this.filters.statuId = event.target.value;
    },
    changeFilterStates(event) {
      this.filters.stateId = event.target.value;
    },
    changeFilterWorkGroups(event) {
      this.filters.workGroupId = event.target.value;
    },
    changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
    },
    changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
    },
    changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
    },
    changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
    },
    selectFoodType(number, value) {
      this.selectedFoodType = number;
      //this.selectedFoodCount = value;
    },
    changeFoodGroupType() {
      var secilen = this.foodGroupList.filter(item => {
        return this.employee.foodGroupId == item.id;
      });
      if (secilen[0]) {
        this.selectedFoodGroupType = secilen[0].type;
      } else {
        this.selectedFoodGroupType = 0;
      }
    },
    filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(a => {
        a.check = false;
      });
      this.foodGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.workGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.stateList.forEach(a => {
        a.isCheck = false;
      });
      this.statuList.forEach(a => {
        a.isCheck = false;
      });
    },
    async getMeals(id, date) {
      try {
        if (id == null || date == null) {
          alertify.error(this.$ml.get("alerts.pleaseCheckFoodGroupAndDate"));
          return;
        }
        var meals = [];
        const response = await this.$axios
          .post("/FoodGroups/GetMealsByFoodGroupId", {
            foodGroupId: id,
            selectedDate: date
          })
          .then(response => {
            if (response.status == 200) {
              meals = response.data;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.meals = meals;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    async getReaders() {
      try {
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                if (doc.doorType == 2) {
                  readers.push({
                    readerNo: doc.readerNo,
                    readerId: doc.readerId,
                    terminalId: doc.terminalId,
                    terminalNo: doc.terminalNo,
                    ipAddress: doc.ipAddress,
                    isActive: doc.isActive,
                    doorType: doc.doorType,
                    name: doc.name
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("alerts.getReadersError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.readers = readers;
        if (this.readers[0]) {
          this.inOut.readerId = this.readers[0].readerId;
        }
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    async getFoodBalanceLogs() {
      try {
        const foodBalanceLogs = [];
        const response = await this.$axios
          .get("/FoodMenu/GetFoodBalanceLogs?empId=" + this.employee.id)
          .then(response => {
            if (response.status == 200) {
              if (response.data) {
                response.data.forEach(doc => {
                  foodBalanceLogs.push({
                    logId: doc.logId,
                    empId: doc.empId,
                    date: doc.date,
                    type: doc.type, //1 kontör 2 bakiye
                    amount: doc.amount,
                    isAdded: doc.isAdded
                  });
                });
              }
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodBalanceLogs = foodBalanceLogs;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    async updateFoodCredit() {
      var credit = null;
      if (this.selectedFoodCount == null || this.selectedFoodCount == 0) {
        alertify.warning(this.$ml.get("alerts.creditNotBlank"));
        return;
      } else {
        credit = parseFloat(this.selectedFoodCount.replace(".", ","));
      }
      if ($.isNumeric(credit) == false) {
        alertify.warning(this.$ml.get("alerts.creditNotBlank"));
        return;
      }
      try {
        let employeeId = this.employee.id;
        let creditType = this.selectedFoodType;
        const response = await this.$axios
          .post("/EmployeeDetails/UpdateCredit", {
            employeeId: employeeId,
            creditType: creditType,
            credit: credit
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        this.selectedFoodCount = 0;
        this.getEmployee(employeeId);
        this.getFoodBalanceLogs();
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async getDepartments() {
      const departments = [];
      try {
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                userId: doc.userId,
                check: false
              });
            });
            departments.sort((a, b) => {
              if (a.locationTree < b.locationTree) return -1;
              if (a.locationTree > b.locationTree) return 0;
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.departments = departments;
        this.sortableTrees();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let subDep = this.departments.filter(function(doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          this.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          this.subDepImport(doc2);
        });
      }
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getTitles() {
      try {
        const titles = [];
        const response = await this.$axios
          .get("/Employees/getTitles")
          .then(response => {
            response.data.forEach(doc => {
              titles.push({
                name: doc
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.titles = titles;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStates() {
      try {
        const states = [];
        const response = await this.$axios
          .get("/Employees/getStates")
          .then(response => {
            response.data.forEach(doc => {
              states.push({
                id: doc.id,
                name: doc.name,
                status: doc.status,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.states = states;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkGroups() {
      try {
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                name: doc.name,
                shortCode: doc.shortCode,
                isPeriod: doc.isPeriod,
                model: doc.model,
                isCheck: false
              });
              workGroups.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 0;
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getExtraFields() {
      try {
        const extrafields = [];
        const response = await this.$axios
          .get("/ExtraField")
          .then(response => {
            response.data.forEach(doc => {
              extrafields.push({
                id: doc.id,
                name: doc.definition
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.extrafields = extrafields;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getRetailSaleLogs() {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmplyeeNotBlank"));
        return;
      }
      if (
        this.retailSaleLogs.startDate == null ||
        this.retailSaleLogs.endDate == null ||
        this.retailSaleLogs.startDate > this.retailSaleLogs.endDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingRetailSale = true;
        const saleLogs = [];
        this.retailSaleLogs.empIds = [];
        this.retailSaleLogs.empIds.push(this.employee.id);
        const response = await this.$axios
          .post("/Reports/SaleReport", this.retailSaleLogs)
          .then(response => {
            response.data.datas[0].veriler.forEach(doc => {
              saleLogs.push(doc);
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingRetailSale = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingRetailSale = false;
              return;
            }
          });
        this.saleLogs = saleLogs;
        this.isLoadingRetailSale = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingRetailSale = false;
      }
    },
    async getInOuts() {
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmplyeeNotBlank"));
        return;
      }
      if (
        this.inOut.inOutStartDate == null ||
        this.inOut.inOutEndDate == null ||
        this.inOut.inOutStartDate > this.inOut.inOutEndDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingInOuts = true;
        const inOuts = [];
        let selectedUser = this.employee.id;
        var startDate = this.inOut.inOutStartDate;
        var endDate = this.inOut.inOutEndDate;
        const response = await this.$axios
          .post("/EmployeeDetails/GetEntryExit", {
            id: selectedUser,
            startDate: startDate,
            endDate: endDate
          })
          .then(response => {
            response.data.forEach(doc => {
              inOuts.push({
                id: doc.id,
                date: doc.date,
                readerName: doc.readerName,
                readerId: doc.readerId,
                doorType: doc.doorType,
                inOrOut: doc.inOrOut,
                price: doc.price,
                isActive: doc.isActive
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingInOuts = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingInOuts = false;
              return;
            }
          });
        this.employee.inOuts = inOuts;
        this.isLoadingInOuts = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingInOuts = false;
      }
    },
    newInOut() {
      this.isNewInOut = true;
      this.inOut.inOutId = null;
      this.inOut.readerId = "";
      this.inOut.inOutType = 1;
      this.inOut.price = 0;
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      this.inOut.inOutAdd = yil + "-" + ay + "-" + gun + "T00:00";
    },
    async selectInOut(id) {
      this.isNewInOut = false;
      let aList = this.employee.inOuts;
      let log = aList.filter(function(doc) {
        return doc.id == id;
      });
      this.inOut.inOutId = id;
      this.inOut.inOutType = log[0].inOrOut;
      this.inOut.inOutAdd = log[0].date;
      this.inOut.readerId = log[0].readerId;
      this.inOut.price = log[0].price;
    },
    async deleteInOut(id) {
      try {
        if (id != 0) {
          const response = await this.$axios
            .delete("/EmployeeDetails/DeleteEntryExit/" + id)
            .then(response => {
              this.getInOuts();
              this.newInOut();
              this.getFoodBalanceLogs();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              }
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingInOuts = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingInOuts = false;
                return;
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    async addInOut() {
      if (this.selectedMealTime == "") {
        alertify.warning(this.$ml.get("alerts.selectedMealNotBlank"));
        return;
      }
      if (this.inOut.inOutAdd == "") {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      if (this.inOut.readerId == "" || this.inOut.readerId == 0) {
        alertify.warning(this.$ml.get("alerts.notSelectedReader"));
        return;
      }
      var selectedDate =
        this.toDateFormat(this.inOut.inOutAdd, "gg.aa.yyyy") +
        "T" +
        this.selectedMealTime;
      var date = new Date(selectedDate);
      var today = new Date();
      if (date > today) {
        alertify.warning(
          this.$ml.get("alerts.cannotCreateMovementInTheFuture")
        );
        return;
      }
      try {
        let empId = this.employee.id;
        let inOurOut = this.inOut.inOutType;
        let inOutAdd = selectedDate;
        let readerId = this.inOut.readerId;
        const response = await this.$axios
          .post("/EmployeeDetails/AddEntryExit", {
            isActive: true,
            inOrOut: inOurOut,
            date: inOutAdd,
            readerId: readerId,
            includePassiveMovements: this.includePassiveMovements,
            doNotDeleteOvertimes: this.doNotDeleteOvertimes,
            empId: empId
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingInOuts = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingInOuts = false;
              return;
            }
          });
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
        } else if (response.status == 201) {
          alertify.error(this.$ml.get("alerts.checkTheMealTime"));
        } else {
          alertify.error(response.message);
        }
        this.getFoodBalanceLogs();
        this.getInOuts();
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async saveEmployee() {
      this.isLoading = true;
      //GÜNCELLE
      if (this.isNewEmployee) {
        alertify.warning(this.$ml.get("alerts.selectedEmplyeeNotBlank"));
        return;
      }
      try {
        let employee2 = this.employee;
        let id = employee2.id;
        const response = await this.$axios
          .post("/FoodMenu/UpdateEmployeeFoodGroup", {
            empId: employee2.id,
            foodGroupId: employee2.foodGroupId
          })
          .then(response => {
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            this.getEmployees();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingInOuts = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingInOuts = false;
              return;
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
      this.isLoading = false;
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.retailSaleLogs.startDate == null) {
        this.retailSaleLogs.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.retailSaleLogs.endDate == null) {
        this.retailSaleLogs.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.inOut.inOutStartDate == null) {
        this.inOut.inOutStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.inOut.inOutEndDate == null) {
        this.inOut.inOutEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.inOut.inOutAdd == null) {
        this.inOut.inOutAdd = yil + "-" + ay + "-" + gun + "T00:00";
      }
    },
    async getEmployee(id) {
      try {
        this.getDefaultDate();
        this.isLoading = true;
        this.tempUrl = null;
        this.imageData = null;
        const response = await this.$axios
          .get("/Employees/" + id)
          .then(response => {
            this.isNewEmployee = false;
            this.employee.id = id;
            this.employee.sicilNo = response.data.sicilNo;
            this.employee.image = response.data.image;
            this.employee.name = response.data.name;
            this.employee.departmentId = response.data.departmentId;
            this.employee.title = response.data.title;
            this.employee.identityNo = response.data.identityNo;
            this.employee.startDate = this.toDateFormat(
              response.data.startDate,
              "gg.aa.yyyy"
            );
            this.employee.endDate = response.data.endDate
              ? this.toDateFormat(response.data.endDate, "gg.aa.yyyy")
              : null;
            this.employee.stateId = response.data.stateId;
            this.employee.stateNote = response.data.stateNote;
            this.employee.terminalNo = response.data.terminalNo;
            this.employee.statuId = response.data.statuId;
            this.employee.cardNo = response.data.cardNo;
            this.employee.terminalStatu = response.data.terminalStatu;
            this.employee.terminalPassword = response.data.terminalPassword;
            this.employee.workGroupId = response.data.workGroupId;
            this.employee.documentNo = response.data.documentNo;
            this.employee.salary = response.data.salary;
            this.employee.overWorkStatus = response.data.overWorkStatus;
            this.employee.mail = response.data.mail;
            this.employee.mobilePhone = response.data.mobilePhone;
            this.employee.birthDayDate = response.data.birthDayDate
              ? this.toDateFormat(response.data.birthDayDate, "gg.aa.yyyy")
              : null;
            this.employee.address = response.data.address;
            this.employee.internalPhone = response.data.internalPhone;
            this.employee.homePhone = response.data.homePhone;
            this.employee.gender = response.data.gender;
            this.employee.educationStatus = response.data.educationStatus;
            this.employee.militaryStatus = response.data.militaryStatus;
            this.employee.drivingLicence = response.data.drivingLicence;
            this.employee.smokeStatus = response.data.smokeStatus;
            this.employee.maritalStatus = response.data.maritalStatus;
            this.employee.bloodType = response.data.bloodType;
            this.employee.height = response.data.height;
            this.employee.weight = response.data.weight;
            this.employee.disabledPercent = response.data.disabledPercent;
            this.employee.authorizedPerson1 = response.data.authorizedPerson1;
            this.employee.authorizedPerson2 = response.data.authorizedPerson2;
            this.employee.note1 = response.data.note1;
            this.employee.note2 = response.data.note2;
            this.employee.foreignLanguage = response.data.foreignLanguage;
            this.employee.accessGroupId = response.data.accessGroupId;
            this.employee.readers = response.data.readers;
            this.employee.foodGroupId = response.data.foodGroupId;
            this.employee.credit = response.data.credit;
            this.employee.remainder = response.data.remainder;
            this.employee.isVisitor = response.data.isVisitor;
            this.employee.visitorCardGroupId = response.data.visitorCardGroupId;
            this.employee.isActive = response.data.isActive;
            this.employee.inOuts = [];
            this.employee.allowences = [];
            this.employee.logs = [];
            this.employee.extrafields = [];
            this.employee.empPayrolls = [];
            this.employee.annualPermitId = response.data.annualPermitId;
            this.employee.annualPermitClaim = response.data.annualPermitClaim;
            this.employee.annualPermitUsed = response.data.annualPermitUsed;
            this.employee.annualPermitRemain = response.data.annualPermitRemain;
            this.employee.annualPermits = response.data.annualPermits;
            this.employee.annualPermitClaimsDates =
              response.data.annualPermitClaimsDates;
            this.employee.annualPermitSeniority =
              response.data.annualPermitSeniority;
            this.employee.annualPermitTransfer =
              response.data.annualPermitTransfer;
            this.employee.hasCard = response.data.hasCard;
            this.employee.hasFace = response.data.hasFace;
            this.employee.hasFinger = response.data.hasFinger;
            this.employee.hasPassword = response.data.hasPassword;
            this.newInOut();
            this.changeFoodGroupType();
            this.getFoodBalanceLogs();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoading = false;
      }
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async clearFilterDepartments() {
      this.filters.departments = [];
      await this.sortableDepartmentList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    async clearFilterAccessGroup() {
      this.filters.accessGroup = [];
      await this.accessGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStates() {
      this.filters.stateId = [];
      await this.stateList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStatus() {
      this.filters.statuId = [];
      await this.statuList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterWorkPlans() {
      this.filters.workGroupId = [];
      await this.workGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterFoodGroups() {
      this.filters.foodGroup = [];
      await this.foodGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.filters.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.filters.departments.push(doc.id);
        }
      });
      let aList2 = this.accessGroupList;
      this.filters.accessGroup = [];
      await aList2.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.accessGroup.push(doc.id);
        }
      });
      let aList3 = this.workGroupList;
      this.filters.workGroupId = [];
      await aList3.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.workGroupId.push(doc.id);
        }
      });
      let aList4 = this.foodGroupList;
      this.filters.foodGroup = [];
      await aList4.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.foodGroup.push(doc.id);
        }
      });
      let aList5 = this.statuList;
      this.filters.statuId = [];
      await aList5.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.statuId.push(doc.id);
        }
      });
      let aList6 = this.stateList;
      this.filters.stateId = [];
      await aList6.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.stateId.push(doc.id);
        }
      });
    },
    async getEmployees() {
      try {
        this.isLoadingEmployee = true;
        await this.getCheckDepartmentList();
        const employees = [];
        let filters2 = this.filters;
        const response = await this.$axios
          .post("/Employees/getByFilter", {
            nameOrCardNumber: filters2.nameOrCardNumber,
            sicilOrTerminalNo: filters2.sicilOrTerminalNo,
            departments: filters2.departments,
            accessGroup: filters2.accessGroup,
            identityNo: filters2.identityNo,
            documentNoOrMail: filters2.documentNoOrMail,
            foodGroup: filters2.foodGroup,
            workGroupId: filters2.workGroupId,
            title: filters2.title,
            stateId: filters2.stateId,
            statuId: filters2.statuId,
            plateNo: filters2.plateNo,
            extraField1key: filters2.extraField1key,
            extraField1value: filters2.extraField1value,
            extraField2key: filters2.extraField2key,
            extraField2value: filters2.extraField2value,
            extraField3key: filters2.extraField3key,
            extraField3value: filters2.extraField3value,
            extraField4key: filters2.extraField4key,
            extraField4value: filters2.extraField4value,
            isVisitor: filters2.isVisitor,
            isActive: filters2.isActive
          })
          .then(response => {
            response.data.forEach(doc => {
              employees.push({
                id: doc.id,
                name: doc.name,
                sicilNo: doc.sicilNo,
                title: doc.title
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 403) {
                alertify.message(
                  this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                );
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
        this.employees = employees;
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    setUserAuthorityFilter(filter) {
      filter.accessGroup
        ? (this.filters.accessGroup = filter.accessGroup)
        : (this.filters.accessGroup = []);
      filter.foodGroup
        ? (this.filters.foodGroup = filter.foodGroup)
        : (this.filters.foodGroup = []);
      filter.workGroupId
        ? (this.filters.workGroupId = filter.workGroupId)
        : (this.filters.workGroupId = []);
      filter.stateId
        ? (this.filters.stateId = filter.stateId)
        : (this.filters.stateId = []);
      filter.statuId
        ? (this.filters.statuId = filter.statuId)
        : (this.filters.statuId = []);
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(doc => {
        this.filters.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(doc => {
        this.filters.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(doc => {
        this.filters.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(doc => {
        this.filters.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(doc => {
        this.filters.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(doc => {
        this.filters.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getDepartments();
    await this.getAccessGroups();
    await this.getStatus();
    await this.getStates();
    await this.getTitles();
    await this.getWorkGroups();
    await this.getExtraFields();
    await this.getReaders();
    await this.getFoodGroups();
    await this.getDefaultDate();
    if (this.defaultFilters) {
      var filter = this.defaultFilters;
      this.setUserAuthorityFilter(filter);
      await this.getEmployees();
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/foodGroupOperations/FoodGroupOperations.vue